import { getLatestPmpsMetadataQueryDocument } from '@utils/(gql)/latest-pmps-metadata.graphql'
import { AsyncData, asyncPoll } from '@utils/async-poll'
import { getBaseUserUrqlClient } from '@/gql/clients/base-user-client'

export async function pollPmpsMetadata(updatedPmpKey: string, token: string, timeSubmitted: string): Promise<void> {
  const client = getBaseUserUrqlClient({ session: null })
  const timeSubmittedUTC = new Date(timeSubmitted).toISOString()

  return await asyncPoll(
    async (): Promise<AsyncData<any>> => {
      try {
        const result = await client
          .query(getLatestPmpsMetadataQueryDocument, { token, key: updatedPmpKey }, { requestPolicy: 'network-only' })
          .toPromise()

        // get latest pmp created at date
        const latestPmp = result.data?.pmps_metadata[0]
        const latestPmpCreatedAt = latestPmp?.created_at

        if (latestPmpCreatedAt && latestPmpCreatedAt >= timeSubmittedUTC) {
          return { done: true, data: token }
        } else {
          return { done: false }
        }
      } catch (err) {
        return Promise.reject(err)
      }
    },
    500,
    30000
  )
}
